import PropTypes from 'prop-types'
import React, { Component } from 'react'
import PackagingOptionsForm from '../PackagingOptionsForm/PackagingOptionsForm'
import { Notification } from '@ynap/notification'
import { Step } from '@ynap/multi-step-form'
import BEMHelper from '@ynap/bem-helper'
import { MetaData } from '../../utils/getMetaData'
import createAnalyticsEvent from '../analytics'
import track from 'react-tracking'

const bem = new BEMHelper('PackagingOptionsStep')

@track()
class PackagingOptionsStep extends Component {
    static propTypes = {
        packagingOptions: PropTypes.array,
        path: PropTypes.string.isRequired,
        nextPath: PropTypes.string,
        locale: PropTypes.object.isRequired,
        setPackagingOption: PropTypes.func.isRequired,
        currentPackagingOption: PropTypes.object,
        isGift: PropTypes.string,
        giftMessage: PropTypes.string,
        disabled: PropTypes.bool,
        completed: PropTypes.bool,
        onChange: PropTypes.func.isRequired,
        messages: PropTypes.object.isRequired,
        config: PropTypes.object.isRequired,
        checkoutAnalytics: PropTypes.object.isRequired,
        handleStepClick: PropTypes.func.isRequired,
        hasShippingMethodChanged: PropTypes.bool,
    }
    componentDidMount() {
        const { packagingOptions, fetchCart } = this.props

        if (!packagingOptions) {
            fetchCart()
        }
    }

    componentDidUpdate(prevProps) {
        const { handleStepClick, hasShippingMethodChanged } = this.props

        if (prevProps.hasShippingMethodChanged !== hasShippingMethodChanged) {
            handleStepClick(!hasShippingMethodChanged)
        }
    }

    renderForm = (props) => {
        const {
            packagingOptions = [],
            setPackagingOption,
            nextPath,
            messages,
            currentPackagingOption,
            isGift,
            giftMessage,
            firstTimeUser,
            config,
            locale,
            checkoutAnalytics,
        } = props
        const isMoreThanOnePackagingOptions = packagingOptions.length > 1

        return (
            <>
                <PackagingOptionsForm
                    packagingOptions={packagingOptions}
                    onSubmit={(values) => {
                        return setPackagingOption(values, nextPath)
                    }}
                    initialValues={{
                        packagingOption: currentPackagingOption && currentPackagingOption.name,
                        isGift,
                        giftMessage,
                    }}
                    messages={messages}
                    firstTimeUser={firstTimeUser}
                    config={config}
                    isMoreThanOnePackagingOptions={isMoreThanOnePackagingOptions}
                    locale={locale}
                    checkoutAnalytics={checkoutAnalytics}
                />
            </>
        )
    }

    renderSummary(props) {
        const { currentPackagingOption, messages, basicOnly } = props
        const packagingOptionKey = currentPackagingOption?.key
        const packagingOptionLabel =
            packagingOptionKey && messages.packagingOptions?.label
                ? messages.packagingOptions.label?.[packagingOptionKey]?.()
                : currentPackagingOption?.description

        return (
            <>
                {basicOnly && messages.notifications?.packagingInfo?.basicOnly && (
                    <Notification className={bem('basic')} message={messages.notifications.packagingInfo.basicOnly()} />
                )}
                <ul className={bem('summary')}>
                    <li>{packagingOptionLabel}</li>
                </ul>
            </>
        )
    }

    @track(({ checkoutAnalytics = {} }) =>
        createAnalyticsEvent({
            ...checkoutAnalytics,
            pageConfigs: {
                pageName: 'checkout - packaging options',
                pageType: 'checkout',
                primaryCategory: 'purchase',
                subCategory1: 'checkout',
                subCategory2: 'packaging options',
            },
        })
    )
    trackPage() {}

    render() {
        const { locale, messages, config, ...rest } = this.props
        const invisible = !this.props.location?.pathname?.includes('/checkout/packaging-options')

        return (
            <>
                {!invisible && <MetaData title={messages.packagingOptions.title()} brandId={config.global.application.brandId} />}
                <Step
                    title={messages.packagingOptions.title()}
                    form={this.renderForm}
                    summary={this.renderSummary}
                    locale={locale}
                    messages={messages}
                    pageAnalyticsStep="packaging options"
                    pageAnalyticsFn={this.trackPage.bind(this)}
                    invisible={invisible}
                    config={config}
                    isCheckoutLayout={true}
                    {...rest}
                />
            </>
        )
    }
}

export default PackagingOptionsStep
